import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from 'src/@core/services/notification.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';
import { ChangeDetectorRef } from '@angular/core';
import { JobService } from 'src/@core/services/job/job.service';
import { AppService } from 'src/@core/services/app.service';
import { EmployerService } from 'src/@core/services/employer/employer.service';
import { Employer } from 'src/@core/interfaces/employer/employer.model';
import { JobTypeService } from 'src/@core/services/job/job-type.service';
import { MatDialog } from '@angular/material';
import { AssignJobAdminComponent } from 'src/app/modules/employment/assign-job-admin/assign-job-admin.component';
import { EmployerUploadService } from 'src/@core/services/employer/employer-upload.service';
import { SuccessModalComponent } from '../success-modal/success-modal.component';
import { Search } from 'src/@core/interfaces/search';
import { SignContractPopupComponent } from '../sign-contract-popup/sign-contract-popup.component';

@Component({
  selector: 'hour4u-admin-add-edit-project',
  templateUrl: './add-edit-project.component.html',
  styleUrls: ['./add-edit-project.component.scss']
})
export class AddEditProjectComponent implements OnInit {

  form: FormGroup;
  jobTypes: any[];
  enterprises: any[];
  roles = roles;
  entityTypes = entityTypes;
  fromWhere: string;
  dialogData: any = {};
  dataFromPopup: boolean;
  submitted = false;
  activationTypes: any;
  selectedFileNames: string[] = [];
  isSocietyActivationSelected: boolean = false;
  selectedValue: any;
  data: any;
  profile = this.appService.getCurrentAccount();
  isSuper: boolean = false;
  employer: Employer;
  @Output() dataRefresh = new EventEmitter();
  totalBill: number = 0;
  selectedData: any = null;
  isUpdate: boolean = false;
  projectFormGroup: FormGroup;

  fieldsType: any[] = [
    {
      name: "",
      type: 'text',
      displyType: 'text',
      label: 'Text Field'
    },
    {
      name: "",
      type: 'tel',
      displyType: 'phone_number_tel',
      label: 'Phone Number'
    },
    {
      name: "",
      type: 'file',
      displyType: 'image_file',
      label: 'Image'
    },
    {
      name: 'order_id',
      type: 'text',
      displyType: 'order_id_text',
      label: 'Order Id'
    },
    {
      name: 'order_image',
      type: 'file',
      displyType: 'order_image_file',
      label: 'Order Image'
    }
  ];

  venueInformationOptions = [
    { value: 'GPS_COORDINATES', display: 'Only GPS co-ordinates' },
    { value: 'FULL_VENUE_INFORMATION', display: 'Full-venue details' }
  ];
  selectedJobData: any = null;
  maxlengthworkTermsAndConditions = 200;
  projectType: string = "";

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _fb: FormBuilder,
    private notify: NotificationService,
    private http: HttpClient,
    private cdRef: ChangeDetectorRef,
    private service: JobService,
    private appService: AppService,
    private employerService: EmployerService,
    private jobTypeService: JobTypeService,
    private dialog: MatDialog,
    private employerUploadService: EmployerUploadService
  ) {
    this.initializeForm();
    this.activationTypes = [
      { value: 'manpower', display: 'Manpower' },
      { value: 'Society Activation', display: 'Society Activation' },
      { value: 'Hotspot', display: 'Hotspot' },
      { value: 'Corporate Activation', display: 'Corporate Activation' },
      { value: 'BRANDING', display: 'Branding' },
    ];

    const navigation = this.router.getCurrentNavigation();
    if (navigation && navigation.extras && navigation.extras.state) {
      this.selectedData = JSON.parse(navigation.extras.state.data).data;
      this.dialogData.data = this.selectedData;
      this.dialogData.title = JSON.parse(navigation.extras.state.data).title;

      // Ensure arrays are initialized to solve error in edit and clone project
      this.dialogData.data.deliverables = this.dialogData.data.deliverables || [];
      this.dialogData.data.rateCards = this.dialogData.data.rateCards || [];
      this.dialogData.data.variableJobRateCards = this.dialogData.data.variableJobRateCards || [];

      this.form.patchValue(this.dialogData.data);
      console.log("#############")
      this.setupFormValues();
      this.isSocietyActivationSelected = this.dialogData.data.type;
      this.projectType = this.dialogData.data.type;
    }
  }


  ngOnInit() {
    // if employer is logged in
    console.log(this.profile)
    if (this.profile.entity.id && (this.profile.entity.entityType === 'ENTERPRISE')) {
      this.form.controls['employerId'].setValue(this.profile.entity.id);
      this.form.controls['employerId'].updateValueAndValidity();
    }
    if (this.profile.entity.entityType === 'AGENCY') {
      this.form.controls['expiryDate'].setValidators([Validators.required]);
      this.form.controls['expiryDate'].updateValueAndValidity();
      this.form.controls['paymentTerms'].setValidators([Validators.required]);
      this.form.controls['paymentTerms'].updateValueAndValidity();
    }
    this.loadJobTypes();
    if (this.profile.entity.entityType === 'AGENCY') {
      this.loadEnterprises();
    }

    // Subscribe to value changes of quantity and rate controls
    const rateCardsArray = this.form.get('rateCards') as FormArray;
    rateCardsArray.controls.forEach((rateCard: FormGroup) => {
      rateCard.get('quantity').valueChanges.subscribe(() => {
        this.updateTotalBill();
      });

      rateCard.get('rate').valueChanges.subscribe(() => {
        this.updateTotalBill();
      });
    });

    // Subscribe to value changes of the entire form
    this.form.valueChanges.subscribe(() => {
      this.updateTotalBill();
    });

  }

  setupFormValues() {
    // if (this.isSuper)
    this.loadJobTypes();

    if (this.dialogData.description) {
      this.form.controls['description'].setValue(this.dialogData.description);
    }

    // if employer is logged in
    if (this.profile.entity.id && (this.profile.entity.entityType === 'ENTERPRISE')) {
      this.form.controls['employerId'].setValue(this.profile.entity.id);
      this.form.controls['employerId'].updateValueAndValidity();
    }

    if (this.dialogData && this.dialogData.data && (this.dialogData.data.id || this.dialogData.data.cloned)) {
      this.isUpdate = true;
      this.form.controls['employerId'].setValue(this.dialogData.data.employerId ? this.dialogData.data.employerId : 'all');
      this.form.controls['employerId'].updateValueAndValidity();
    }
    console.log(this.dialogData)
    if (this.dialogData) {
      if (this.dialogData.from) {
        this.fromWhere = this.dialogData.from;
      }
      if (this.dialogData.jobTypeId) {
        if (this.fromWhere == 'Shifts') {
          this.form.controls['jobTypeId'].setValue(this.dialogData.jobTypeId);
          this.form.controls['jobTypeId'].updateValueAndValidity();
          if (this.isSuper) {
            this.form.controls['employerId'].setValue(this.dialogData.employerId ? this.dialogData.employerId : 'all');
            this.form.controls['employerId'].updateValueAndValidity();
          }
        }
      }
      const deliverables = this.form.get('deliverables') as FormArray;
      deliverables.clear();
      if (this.dialogData.data.deliverables) {
        console.log("this.dialogData.data.deliverables-", this.dialogData.data.deliverables)
        this.dialogData.data.deliverables.forEach((element, index) => {
          deliverables.push(this.createDeliverable());
          deliverables.controls[index].patchValue(element)
        });
        console.log(deliverables)
      }

      const rateCards = this.form.get('rateCards') as FormArray;
      rateCards.clear();
      if (this.dialogData.data.rateCards && this.dialogData.data.rateCards.length) {
        this.dialogData.data.rateCards.forEach((element, index) => {
          rateCards.push(this.createRateCard());
          rateCards.controls[index].patchValue(element)
        });
      }

      const variableJobRateCards = this.form.get('variableJobRateCards') as FormArray;
      variableJobRateCards.clear();
      if (this.dialogData.data.variableJobRateCards && this.dialogData.data.variableJobRateCards.length) {
        this.dialogData.data.variableJobRateCards.forEach((element, index) => {
          variableJobRateCards.push(this.createVariableRateCard());
          variableJobRateCards.controls[index].patchValue(element)
        });
      }
      this.getJobById();
      this.form.patchValue(this.dialogData.data);
      this.totalBill = this.calculateTotalBill();
    }
  }

  loadEnterprises() {
    let searchParams = [];
    this.enterprises = [];
    const entityId = this.profile.entity.id;
    // this.isLoading = true;

    if (entityId) {
      searchParams.push(new Search('fetchParent', true));

      searchParams.push(new Search('entityType', 'ENTERPRISE'));
      this.service.searchAndSortAgencies(
        entityId,
        0,
        1000,
        'createdOn',
        'desc',
        searchParams
      ).subscribe(
        (data) => {
          this.enterprises = data.content;
          // this.isLoading = false;
          console.log(this.enterprises);
          // this.resultsLength = data.totalElements;
        },
        (error) => {
          // this.isLoading = false;
          this.notify.showMessage('Something went wrong!', 2000);
        }
      );

    } else {
      console.warn('Entity ID is not available. Unable to fetch enterprises.');
    }
  }

  getJobById() {
    let params = {};
    if (this.profile && this.profile.entity && this.profile.entity.id) {
      if (this.profile.entity.entityType == 'AGENCY') {
        params = { 'entityId': this.profile.entity.id };
      }
    }
    if (this.dialogData.data && this.dialogData.data.id) {
      this.service.getJobDetailsById(this.dialogData.data.id, params).subscribe((job: any) => {
        this.selectedJobData = job;
        console.log(this.selectedJobData)
        if (this.selectedJobData && this.selectedJobData.billingType && this.selectedJobData.billingType) {
          this.form.controls['billingType'].setValue(this.selectedJobData.billingType && this.selectedJobData.billingType);
          this.form.controls['billingType'].updateValueAndValidity();

          if (this.selectedJobData.billingType == "NONE") {
            this.form.controls['isBillingRequired'].setValue(false);
            this.form.controls['isBillingRequired'].updateValueAndValidity();
          }

          if (this.selectedJobData.quoteConditions) {
            console.log(this.selectedJobData.quoteConditions)
            if (this.selectedJobData.quoteConditions.additionalTermsAndConditions) {
              this.form.controls['additionalTermsAndConditions'].setValue(this.selectedJobData.quoteConditions.additionalTermsAndConditions);
            }
            if (this.selectedJobData.quoteConditions.expiryDate) {
              this.form.controls['expiryDate'].setValue(new Date(this.selectedJobData.quoteConditions.expiryDate));
            }
            if (this.selectedJobData.quoteConditions.paymentTerms) {
              this.form.controls['paymentTerms'].setValue(this.selectedJobData.quoteConditions.paymentTerms);
            }
            this.form.controls['additionalTermsAndConditions'].updateValueAndValidity();
            this.form.controls['expiryDate'].updateValueAndValidity();
            this.form.controls['paymentTerms'].updateValueAndValidity();
          }
        }
      })
    } else {
      this.service.getJobDetailsById(this.dialogData.data.jobId, params).subscribe((job: any) => {
        if (job.quoteConditions) {
          console.log(job.quoteConditions)
          if (job.quoteConditions.additionalTermsAndConditions) {
            this.form.controls['additionalTermsAndConditions'].setValue(job.quoteConditions.additionalTermsAndConditions);
          }
          if (job.quoteConditions.expiryDate) {
            this.form.controls['expiryDate'].setValue(new Date(job.quoteConditions.expiryDate));
          }
          if (job.quoteConditions.paymentTerms) {
            this.form.controls['paymentTerms'].setValue(job.quoteConditions.paymentTerms);
          }
          this.form.controls['additionalTermsAndConditions'].updateValueAndValidity();
          this.form.controls['expiryDate'].updateValueAndValidity();
          this.form.controls['paymentTerms'].updateValueAndValidity();
        }
        this.dialogData.data.jobId = null;
      })
    }
  }

  updateTotalBill() {
    this.totalBill = this.calculateTotalBill();
  }


  initializeForm() {
    this.form = this._fb.group({
      id: [''],
      jobTypeId: ['', Validators.required],
      employerId: ['', Validators.required],
      employerName: [''],
      title: ['', Validators.required],
      dressCodeMale: [''],
      dressCodeFemale: [''],
      description: [''],
      tasks: [''],
      requirements: [''],
      prerequisites: [''],
      city: [''],
      type: [''],
      manpowerTrackingRequired: [false],
      attendanceLogInSelfieRequired: [false],
      attendanceLogOutSelfieRequired: [false],
      attendanceLocationTrackerRequired: [false],
      quotationRequired: [false],
      locationTrackingFrequency: [],
      geoFencingRadius: [],
      attachments: this._fb.array([]),
      elements: this._fb.array([this.createElement()]),
      deliverables: this._fb.array([this.createDeliverable()]),
      rateCards: this._fb.array([]),
      variableJobRateCards: this._fb.array([]),
      venueInformation: ['', Validators.required],
      isBillingRequired: [true],
      billingType: ['FIXED'],
      expiryDate: [''],
      paymentTerms: [''],
      additionalTermsAndConditions: [''],
      signatureRequired: [false],
      workOrderApprovalRequired: [true],
      quotationApprovalRequired: [true],
      purchaseOrderRequired: [true]
    });
  }

  setIfBillingRequiredOrNot(event) {
    console.log(event, this.form.value)
    const variableRateCardsArray = this.form.get('variableJobRateCards') as FormArray;
    const rateCardsArray = this.form.get('rateCards') as FormArray;
    if (!event.checked) {
      this.form.controls['billingType'].setValue('NONE');
      this.form.controls['billingType'].updateValueAndValidity();
      this.form.controls['paymentTerms'].setValidators([]);
      this.form.controls['paymentTerms'].updateValueAndValidity();
      if (this.form.controls['billingType'].value.includes('NONE')) {
        console.log("+++++++++++++")
        variableRateCardsArray.clear();
        rateCardsArray.clear();
      }
      this.updateTotalBill();
      return;
    } else {
      this.form.controls['billingType'].setValue('FIXED');
      this.form.controls['billingType'].updateValueAndValidity();
      this.form.controls['paymentTerms'].setValidators([Validators.required]);
      this.form.controls['paymentTerms'].updateValueAndValidity();
      if (this.form.controls['billingType'].value.includes('FIXED')) {
        variableRateCardsArray.clearValidators();
      }

      if (this.form.controls['billingType'].value.includes('VARIABLE')) {
        rateCardsArray.clearValidators();
        this.setDefaultVariablePay();
      }
    }
  }

  setIfManpowerTrackingRequiredOrNot(event) {
    console.log(event)
    if (event.checked) {
      this.form.controls['attendanceLogInSelfieRequired'].setValue(true);
      this.form.controls['attendanceLogOutSelfieRequired'].setValue(true);
      this.form.controls['attendanceLocationTrackerRequired'].setValue(true);
      this.form.controls['locationTrackingFrequency'].setValue("");
      this.form.controls['geoFencingRadius'].setValue("");
      this.form.controls['locationTrackingFrequency'].setValidators([Validators.required])
      this.form.controls['geoFencingRadius'].setValidators([Validators.required])
    } else {
      this.form.controls['attendanceLogInSelfieRequired'].setValue(false);
      this.form.controls['attendanceLogOutSelfieRequired'].setValue(false);
      this.form.controls['attendanceLocationTrackerRequired'].setValue(false);
      this.form.controls['locationTrackingFrequency'].setValue("");
      this.form.controls['geoFencingRadius'].setValue("");
      this.form.controls['locationTrackingFrequency'].setValidators([])
      this.form.controls['geoFencingRadius'].setValidators([])
    }

    this.form.controls['attendanceLogInSelfieRequired'].updateValueAndValidity();
    this.form.controls['attendanceLogOutSelfieRequired'].updateValueAndValidity();
    this.form.controls['attendanceLocationTrackerRequired'].updateValueAndValidity();
    this.form.controls['locationTrackingFrequency'].updateValueAndValidity();
    this.form.controls['geoFencingRadius'].updateValueAndValidity();
  }


  onFileSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;

    if (inputElement.files && inputElement.files.length > 0) {
      const attachmentsArray = this.form.get('attachments') as FormArray;

      for (let i = 0; i < inputElement.files.length; i++) {
        const file = inputElement.files[i];

        // Upload the file to S3 using the existing function
        this.employerUploadService.uploadProfileImage(file).subscribe(
          (s3File) => {
            console.log('File uploaded successfully:', s3File);

            attachmentsArray.push(this._fb.control(s3File.key));
            this.selectedFileNames.push(file.name);
          },
          (error) => {
            console.error('Error uploading file:', error);
          }
        );
      }
    }
  }



  // This method fetches job types and populates the dropdown
  loadJobTypes() {
    this.jobTypeService.searchAndSort(0, 1000, null, null).subscribe(data => {
      // this.jobTypes = data.content;
      if (data.content && data.content.length) {
        this.jobTypes = data.content.filter((category: any) => category.name !== "INTERNAL");
      }
    });
  }

  // This method is triggered when the user selects a job type from the dropdown
  onJobTypeSelectionChange(event: any) {
    const selectedJobTypeId = event.value;

    // Additional logic to fetch details if needed
    // ...

    // Set the selected jobTypeId in the form
    this.form.controls['jobTypeId'].setValue(selectedJobTypeId);
    this.form.controls['jobTypeId'].updateValueAndValidity();
  }





  // Method to add more 'rateCards'
  addMoreRateCards() {
    const rateCardsArray = this.form.get('rateCards') as FormArray;
    rateCardsArray.push(this.createRateCard());
  }

  addMoreVariableRateCards() {
    const variableRateCardsArray = this.form.get('variableJobRateCards') as FormArray;
    variableRateCardsArray.push(this.createVariableRateCard());
  }

  enableEdit(rateCard: FormGroup) {
    rateCard.get('saved').setValue(false);
    rateCard.enable(); // Enable the entire rate card FormGroup
  }

  // Method to delete a specific 'rateCard' by index
  deleteRateCard(index: number) {
    const rateCardsArray = this.form.get('rateCards') as FormArray;
    rateCardsArray.removeAt(index);
  }

  // Method to delete a specific 'rateCard' by index
  deleteVariableRateCard(index: number) {
    const variableRateCardsArray = this.form.get('variableJobRateCards') as FormArray;
    variableRateCardsArray.removeAt(index);
  }

  createElement(): FormGroup {
    return this._fb.group({
      fieldLabel: [''],
      fieldType: [''],
      displayFieldType: [''],
      fieldName: [''],
      isMandatory: [false]
    });
  }

  createRateCard(defaultType: string = ''): FormGroup {
    console.log("defaultType", defaultType)
    return this._fb.group({
      type: [defaultType],
      quantity: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      rate: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      totalAmount: [''],
      saved: [false]
    });
  }

  createVariableRateCard(defaultType: string = ''): FormGroup {
    console.log("defaultType", defaultType)
    return this._fb.group({
      type: [defaultType],
      quantity: [''],
      rate: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      totalAmount: [''],
      saved: [false]
    });
  }


  calculateTotalBill(): number {
    this.totalBill = 0;
    const rateCards = this.form.get('rateCards') as FormArray;
    rateCards.controls.forEach((rateCard: FormGroup) => {
      const quantity = rateCard.get('quantity').value;
      const rate = rateCard.get('rate').value;
      this.totalBill += quantity * rate;
    });

    return this.totalBill;
  }


  setFieldLabel(field: any, index: number) {
    console.log(field)
    const deliverables = this.form.get('deliverables') as FormArray;
    const deliverable = deliverables.at(index) as FormGroup;
    console.log("deliverable=======", deliverable)
    if (deliverable) {
      deliverable.get('fieldType').setValue(field.type);
      deliverable.get('displayFieldType').setValue(field.displyType);
    }
    if (field && field.name != 'order_id' && field.name != 'order_image') {
      if (deliverable) {
        const fieldName = deliverable.get('fieldLabel').value;
        if (fieldName) {
          const lowerCaseName = fieldName.replaceAll(' ', '_').toLowerCase();
          if (deliverable.get('fieldType').value.includes('file')) {
            deliverable.get('fieldName').setValue(lowerCaseName + '_image_' + index);
          } else {
            deliverable.get('fieldName').setValue(lowerCaseName + '_' + index);
          }
        }
      }
    } else {
      if (field.name == 'order_id') {
        const fieldNameToCheck = "order_id";
        if (this.form.get('deliverables').value && this.form.get('deliverables').value.length) {
          const isFieldNameAvailable = this.form.get('deliverables').value.some(item => item.fieldName === fieldNameToCheck);
          if (isFieldNameAvailable) {
            // deliverable.get('fieldType').setValue("");
            deliverable.get('displayFieldType').setValue("");
            deliverable.get('fieldName').setValue("");
            this.notify.showMessage(`Field with "${fieldNameToCheck}" is available in the deliverales.`, 2000);
          } else {
            deliverable.get('fieldName').setValue(field.name);
            deliverable.get('fieldLabel').setValue(field.label);
            deliverable.get('displayFieldType').setValue(field.displyType);
            deliverable.get('fieldType').setValue(field.type);
          }
        } else {
          deliverable.get('fieldName').setValue(field.name);
        }
      }
      if (field.name == 'order_image') {
        const fieldNameToCheck = "order_image";
        if (this.form.get('deliverables').value && this.form.get('deliverables').value.length) {
          const isFieldNameAvailable = this.form.get('deliverables').value.some(item => item.fieldName === fieldNameToCheck);
          if (isFieldNameAvailable) {
            // deliverable.get('fieldType').setValue("");
            deliverable.get('displayFieldType').setValue("");
            deliverable.get('fieldName').setValue("");
            this.notify.showMessage(`Field with "${fieldNameToCheck}" is available in the deliverales.`, 2000);
          } else {
            deliverable.get('fieldName').setValue(field.name);
            deliverable.get('fieldLabel').setValue(field.label);
            deliverable.get('displayFieldType').setValue(field.displyType);
            deliverable.get('fieldType').setValue(field.type);
          }
        } else {
          deliverable.get('fieldName').setValue(field.name);
        }
      }
    }

    console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$44", deliverables.value)
  }

  deleteDeliverable(index: number) {
    const deliverables = this.form.get('deliverables') as FormArray;
    deliverables.removeAt(index);
  }

  addMoreDeliverables() {
    const deliverables = this.form.get('deliverables') as FormArray;
    const newDeliverable = this.createDeliverable();
    newDeliverable.get('isMandatory').setValue(true); // Set 'isMandatory' to true for the new row
    deliverables.push(newDeliverable);
  }


  createDeliverable(): FormGroup {
    return this._fb.group({
      fieldLabel: ['', [Validators.required]],
      fieldType: ['', [Validators.required]],
      fieldName: ['', [Validators.required]],
      displayFieldType: ['', [Validators.required]],
      isMandatory: [false],
      //saved: [false]
    });
  }

  onSave(signContract: boolean = false): void {
    console.log("on save called");
    this.submitted = true;
    console.log(this.form)

    // Remove the premature return statement
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.submitted = false;
      console.log("is returning?");
      return;
    }

    if (this.profile.entity.entityType === 'AGENCY') {
      this.form.controls['quotationRequired'].setValue(true);
      this.form.controls['quotationRequired'].updateValueAndValidity();
    } else {
      this.form.controls['employerName'].setValue(this.profile.user.userMeta.name);
      this.form.controls['employerName'].updateValueAndValidity();
    }

    this.form.controls['signatureRequired'].setValue(signContract);
    this.form.controls['signatureRequired'].updateValueAndValidity();

    const formData = this.form.value;
    formData.rateCards.forEach(element => {
      element.totalAmount = element.quantity * element.rate
    });

    const dateString = this.form.controls['expiryDate'].value;
    const dateObj = new Date(dateString);
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();
    const resultArray: number[] = [year, month, day];

    formData.quoteConditions = {
      "expiryDate": resultArray,
      "paymentTerms": this.form.controls['paymentTerms'].value,
      "additionalTermsAndConditions": this.form.controls['additionalTermsAndConditions'].value
    }

    if (this.projectType == 'BRANDING') {
      formData.projectType = this.projectType;
    }
    // Set employerName field
    // formData.employerName = 'Your Employer Name'; // Replace with the actual value

    // Convert tasks to an array if it's a string
    if (typeof formData.tasks === 'string') {
      formData.tasks = [formData.tasks];
    } else {
      formData.tasks = formData.tasks ? formData.tasks : [];
    }

    // Add venueInformation to formData
    formData.venueInformation = this.form.value.venueInformation;
    console.log(formData)
    if (!signContract) {
      if (this.form.value.id) {
        // Update existing project
        this.service.update(this.form.value.id, formData).subscribe(
          (data) => {
            this.submitted = false;
            this.notify.showMessage("Project updated successfully!", 2000);
            this.router.navigate(['/job'], { relativeTo: this.route });
            if (this.profile.entity.entityType === 'ENTERPRISE') {
              this.openSuccessModal(data, 'Updated');
            }
          },
          (error: HttpErrorResponse) => {
            this.submitted = false;
            this.notify.showMessage("Error while updating project!", 2000);
          }
        );
      } else {
        // Create new project
        this.service.create(formData).subscribe(
          (data) => {
            this.submitted = false;
            this.notify.showMessage("Project created successfully!", 2000);
            this.router.navigate(['/job'], { relativeTo: this.route });
            if (this.profile.entity.entityType === 'ENTERPRISE') {
              this.openSuccessModal(data, 'Created');
            }
          },
          (error: HttpErrorResponse) => {
            this.submitted = false;
            this.notify.showMessage("Error while creating project!", 2000);
          }
        );
      }
    } else {
      this.openSignContractPopUp(formData);
    }
  }

  openSignContractPopUp(formData) {
    console.log(formData)
    localStorage.setItem("selectedPojectData", JSON.stringify(formData));
    if (formData.id) {
      this.router.navigate(['/job/signed-doc/' + formData.id]);
    } else {
      this.router.navigate(['/job/signed-doc']);
    }
    // const dialogRef = this.dialog.open(SignContractPopupComponent, {
    //   width: '600px',
    //   panelClass: 'assign-dialog',
    //   disableClose: true,
    //   data: formData
    // });
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
    //     this.dataRefresh.emit();
    //   }
    // });
  }





  jobTypeChanged(event) {
    // Ensure that the event object and its target property exist
    if (event && event.source && event.source.value) {
      //  your event contains the selected job type ID
      const selectedJobTypeId = event.source.value;

      // Find the selected job type in the jobTypes array
      const selectedJobType = this.jobTypes.find(jobType => jobType.id === selectedJobTypeId);

      // Update the first element in the rateCards array with the selected job type name
      const rateCards = this.getRateCardsControls();
      if (rateCards.length > 0 && selectedJobType) {
        const firstRateCard = rateCards[0] as FormGroup;
        firstRateCard.get('type').setValue(selectedJobType.name);
      }

      // Check if "Society Activation" is selected
      // this.isSocietyActivationSelected = selectedJobType.name == "society-activation";
      console.log('Selected Job Type:', selectedJobType ? selectedJobType.name : 'Not Found');
      console.log('Is Society Activation Selected:', this.isSocietyActivationSelected);
    }
  }

  activationTypeChanged(event?: any) {
    // Set isSocietyActivationSelected to true
    this.isSocietyActivationSelected = true;

    const rateCardsArray = this.form.get('rateCards') as FormArray;

    if (rateCardsArray.length === 0) {
      // Create default rate cards if they are not already created
      this.setDefaultFixedPay();
    }

    this.setDefaultVariablePay();
    // Update total bill after changing activation type
    this.updateTotalBill();
  }

  selectedBillingOption() {
    this.setDefaultVariablePay();
    console.log(this.form.controls['billingType'].value)
    const variableRateCardsArray = this.form.get('variableJobRateCards') as FormArray;
    const rateCardsArray = this.form.get('rateCards') as FormArray;
    if (this.form.controls['billingType'].value == 'FIXED') {
      rateCardsArray.clear();
      variableRateCardsArray.clear();
      this.setDefaultFixedPay();
    }

    if (this.form.controls['billingType'].value == 'VARIABLE') {
      rateCardsArray.clear();
      variableRateCardsArray.clear();
      this.setDefaultVariablePay();
    }

    if (this.form.controls['billingType'].value == 'FIXED_AND_VARIABLE') {
      rateCardsArray.clear();
      variableRateCardsArray.clear();
      this.setDefaultFixedPay();
      this.setDefaultVariablePay();
    }
  }

  setDefaultFixedPay() {
    const rateCardsArray = this.form.get('rateCards') as FormArray;
    rateCardsArray.clear();
    if (this.form.value.billingType.includes("FIXED")) {
      if (this.projectType == 'BRANDING') {
        rateCardsArray.push(this.createRateCard());
      } else {
        rateCardsArray.push(this.createRateCard('Promoters'));
        rateCardsArray.push(this.createRateCard('Transportation'));
        rateCardsArray.push(this.createRateCard('Goods for activity'));
      }
    }
  }

  setDefaultVariablePay() {
    const variableRateCardsArray = this.form.get('variableJobRateCards') as FormArray;
    variableRateCardsArray.clear();
    if (this.form.value.billingType.includes("VARIABLE")) {
      variableRateCardsArray.push(this.createVariableRateCard('Tasks'));
    }
  }


  getRateCardsControls(): AbstractControl[] {
    return (this.form.get('rateCards') as FormArray).controls;
  }
  getvariableJobRateCardsControls(): AbstractControl[] {
    return (this.form.get('variableJobRateCards') as FormArray).controls;
  }

  // ASSIGN ADMIN DIALOG
  assignAgency(data): void {
    // const employmentAdmin = new EmploymentAdministration();
    // employmentAdmin.employmentId = id;
    const dialogRef = this.dialog.open(AssignJobAdminComponent, {
      width: '600px',
      panelClass: 'assign-dialog',
      disableClose: true,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dataRefresh.emit();
      }
    });
  }


  openSuccessModal(data?: any, action?: string) {
    data.action = action;
    const dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '600px',
      panelClass: 'assign-dialog',
      disableClose: true,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dataRefresh.emit();
      }
    });
  }

  changeLocationTracking(event: any) {
    if (event.checked) {
      this.form.controls['locationTrackingFrequency'].setValidators(Validators.required);
      this.form.controls['geoFencingRadius'].setValidators(Validators.required);
    } else {
      this.form.controls['locationTrackingFrequency'].setValidators([])
      this.form.controls['geoFencingRadius'].setValidators([])
    }
    this.form.controls['locationTrackingFrequency'].updateValueAndValidity();
    this.form.controls['geoFencingRadius'].updateValueAndValidity();
  }

  selectedEnterprise(enterprise) {
    this.form.controls['employerName'].setValue(enterprise.entityMeta.name);
    this.form.controls['employerName'].updateValueAndValidity();
  }

  selectedProjectType(projectType) {
    this.projectType = projectType.value;
    console.log(this.projectType)
    const rateCardsArray = this.form.get('rateCards') as FormArray;
    rateCardsArray.clear()
    this.setDefaultFixedPay();
    if (this.projectType == 'BRANDING') {
      this.form.controls['jobTypeId'].setValidators([]);
      this.form.controls['jobTypeId'].updateValueAndValidity();
    } else {
      this.form.controls['jobTypeId'].setValidators([Validators.required]);
      this.form.controls['jobTypeId'].updateValueAndValidity();
    }
  }

  logQuotationApprovalRequired(value: boolean): void {
    this.form.get('purchaseOrderRequired').setValue(false);
    console.log('Quotation Approval Required:', value);
  }

  deleteSelectedFile(index) {
    console.log(index);
    this.selectedFileNames.splice(index, 1);
  }
}
